import React, { useState } from "react";
import CreateLeadModal from "./CreateLeadModal";
import "../css/LeadsHeader.css";
import NYClock from "../../components/NYClock";

export default function LeadsHeader() {
  const [openCreate, setOpenCreate] = useState(false);

  return (
    <header className="leads-header">
      <div className="lh-left">
        <NYClock />
      </div>

      <div className="lh-right">
        <div className="lh-avatars">
          <img src="https://i.pravatar.cc/36?img=12" alt="A" />
          <img src="https://i.pravatar.cc/36?img=15" alt="B" />
          <img src="https://i.pravatar.cc/36?img=3" alt="C" />
          <img src="https://i.pravatar.cc/36?img=32" alt="D" />
          <img src="https://i.pravatar.cc/36?img=7" alt="E" />
        </div>
        <button className="lh-primary" onClick={() => setOpenCreate(true)}>
          + Create Lead
        </button>
      </div>

      <CreateLeadModal
        open={openCreate}
        onClose={() => setOpenCreate(false)}
        onCreated={(lead) => {
          console.log("Lead created:", lead);
        }}
      />
    </header>
  );
}
